import { injectable } from 'inversify';
import { observable } from 'mobx';

@injectable()
export class NotifyStore {

    // app = firebase.app();
    @observable token;

    constructor() {
        //
    }

    async configure() {
        /*try {
            console.log(this.app);

            const token = await this.app.messaging().getToken();

            if (token) {
                console.log('token', token);
            } else {
                console.log('failed');
            }
        } catch (e) {
            console.log('error', e);
            this.token = undefined;
        }*/
    }

}
